import { render, staticRenderFns } from "./Carbodies.vue?vue&type=template&id=ba9b633e"
import script from "./Carbodies.vue?vue&type=script&lang=js"
export * from "./Carbodies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports